import {SocialBar as SocialBarCommons} from '../../../../../commons/components/social-bar'
import {getEventUrl} from '../../../../../commons/selectors/event'
import {isEventsInMembersInstalled} from '../../../../../commons/selectors/installed-apps'
import {isShareOptionsVisible} from '../../selectors/single-settings'
import {AppProps} from '../app/interfaces'
import {renderIfVisible} from '../hoc/render-if-visible'
import {connect} from '../runtime-context/connect'
import {SocialBarConnectProps, SocialBarProps, SocialBarStateProps} from './interfaces'

const mapRuntime = (
  {pageUrl, state, actions}: AppProps,
  {event, hideTitle}: SocialBarConnectProps,
): SocialBarStateProps => ({
  eventUrl: getEventUrl(pageUrl.url, event, state.multilingual),
  eventId: event.id,
  hideTitle: isEventsInMembersInstalled(state) || hideTitle,
  onShare: actions.shareEvent,
})

export const SocialBar = connect<SocialBarProps>(mapRuntime)(SocialBarCommons)

export const SingleEventSocialBar = renderIfVisible<SocialBarProps>(SocialBar, isShareOptionsVisible)
